import { AxiosError } from 'axios';
import { EValidations, ErrorStateUIData, validationsRegExp } from '../../models/interfaces';
import { IErrorGlobal } from '../store/model/store.model';
import i18n from 'i18next';

export function setInfoError(error: any): ErrorStateUIData {
    const httpCode = Number(error?.response?.status);
    const criticalError: { [key: string]: string } = {
        401: i18n.t('error401'),
        403: i18n.t('error403'),
        410: i18n.t('error410'),
    };
    let localizedDescription = [401, 403, 410].includes(httpCode)
        ? criticalError[httpCode]
        : i18n.t('errorGenericDescription');
    let errorResponse: ErrorStateUIData = {
        title: i18n.t('supportErrorProblemsTitle'),
        localizedDescription,
        id: error?.response?.status,
        httpCode: error?.response?.status || null,
    };
    if (error?.response?.data?.localizedDescription) {
        errorResponse.localizedDescription = error.response.data?.localizedDescription;
        errorResponse.id = error.response.data?.id || '';
    }
    return errorResponse;
}

export const handleErrorMessage = (error: AxiosError) => {
    const { title, localizedDescription, id, httpCode } = setInfoError(error);
    let _error: IErrorGlobal = {
        status: true,
        data: {
            title,
            localizedDescription,
            id,
            httpCode,
        },
        pathname: window.location.href.split(window.location.host)[1],
    };
    window.sessionStorage.setItem('error', JSON.stringify(_error.data));
    return _error;
};

export const handleValidationRegExp = (value: string, type: EValidations) =>
    new RegExp(validationsRegExp[type]).test(value);

//Errores de SEGU
export const obdTextErrorCode: { [key: string]: string } = {
    '57': 'Hemos detectado que el documento no coincide con el titular de la línea.\n\nPara poder verificar los medios de contacto, debes ser el titular.',
    '0': 'No hemos podido capturar correctamente el documento o no es válido. Por favor, realiza la verificación avanzada de nuevo.',
    '24': 'Usuario bloqueado administrativamente',
    '53': 'Te pedimos disculpas, no hemos podido realizar la verificación avanzada.',
    '56': 'Te pedimos disculpas, no hemos podido realizar la verificación avanzada',
    '721': 'No es posible finalizar el proceso de cambio de titular.\n\nRecuerde que el documento de identidad tiene que coincidir con el indicado previamente por el titular actual de la linea.\n\nPor favor, inténtalo de nuevo más tarde.',
};

//Errores de DAON
export const obdTextErrorDescription: { [key: string]: string } = {
    'Document Screen Replay detection validation failed.':
        'Has presentado un documento en una pantalla.\nPor favor, haz una foto al documento original.',
    'User is not over 16': 'El documento pertenece a un menor 16 años. No podemos realizar la verificación avanzada.',
    'Document expired': 'Tu documento ha caducado.\nNo podemos realizar la verificación avanzada.',
    'Id Document Not Present':
        'No hemos podido capturar correctamente el documento o no es válido.\nPor favor, realiza la verificación avanzada de nuevo.',
    'Face mismatch':
        'La foto de tu selfi y la del documento no coinciden.\nPor favor, realiza la verificación avanzada de nuevo.',
    'To many validations failed. Your application has been declined.':
        'Te pedimos disculpas, no hemos podido realizar la verificación avanzada.',
    'Document photocopy validation failed':
        'No podemos validar la captura de una fotocopia.\nPor favor, utiliza el documento original',
    'Only one source read (MRZ or VIZ not processed correctly).':
        'No hemos podido capturar correctamente el documento o no es válido.\nPor favor, realiza la verificación de nuevo.',
    'NIE without a picture':
        'El documento mostrado no tiene fotografía.\nPor favor, muestra tu DNI o NIE con foto para poder realizar la verificación.',
};
